import { render, staticRenderFns } from "./ModalAuthorizationNotify.vue?vue&type=template&id=556ae0af"
import script from "./ModalAuthorizationNotify.vue?vue&type=script&lang=js"
export * from "./ModalAuthorizationNotify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports